<template>
  <div id="swap" class="invite">
    <div class="top">
      <h1>兑换课时 📚</h1>
      <p>
        除了赢取现金之外，您也可以选择兑换
        <router-link tag="span" class="red" to="/courses">{{ course_reward }}</router-link>。每邀请 1 人，即可
        <router-link to="/contact" tag="span" class="red">联系小管家</router-link>&nbsp; 兑换课时。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "swap",
  props: ["course_reward"],
}
</script>

<style lang="scss" scoped>
// @import "../../../../static/css/public.scss";
@import "./style.scss";

#swap {
}
</style>
